import { call, takeLatest, all, fork, put } from "redux-saga/effects"
import * as salesRepAI from '../../services/salesRepClassificationAPI';
import { CLEAR_API_CALL_MESSAGE, GET_AI_RECOMMENDATION_SALES_REP_CLASSIFICATION, GET_AI_RECOMMENDATION_SALES_REP_CLASSIFICATION_FAILURE, GET_AI_RECOMMENDATION_SALES_REP_CLASSIFICATION_SUCCESS, GET_SALES_REP_CLASSIFICATION_LIST, GET_SALES_REP_CLASSIFICATION_LIST_FAILURE, GET_SALES_REP_CLASSIFICATION_LIST_SUCCESS } from "../Action/actionTypes";
import { apiCallFailure, apiCallRequest } from "../Action/Action";




//worker saga methods 
function* getAIDataForSalesRep(action: any): Generator {
    try {
        yield put(apiCallRequest());
        const payload = action.payload
        const response: any = yield call(salesRepAI.getApiForSalesRepAIData, payload);
        if (response.status === 200) {
            yield put({ type: GET_AI_RECOMMENDATION_SALES_REP_CLASSIFICATION_SUCCESS, payload: response.data.result })
            yield put({ type: CLEAR_API_CALL_MESSAGE })
        } else {
            yield put(apiCallFailure("Failed to fetch AI recommendations.Please try again."));
            yield put({ type: GET_AI_RECOMMENDATION_SALES_REP_CLASSIFICATION_FAILURE, payload: '' })
        }
    } catch (e) {
        yield put({ type: GET_AI_RECOMMENDATION_SALES_REP_CLASSIFICATION_FAILURE, payload: e })
    }
}

function* getSalesRepClassificationListData(): Generator {
    try {
        const response: any = yield call(salesRepAI.getSalesRepClassificationListAPI);
        if (response.status === 200) {
            yield put({ type: GET_SALES_REP_CLASSIFICATION_LIST_SUCCESS, payload: response.data.result })
        } else {
            yield put({ type: GET_SALES_REP_CLASSIFICATION_LIST_FAILURE })
        }
    } catch (error) {
        yield put({ type: GET_SALES_REP_CLASSIFICATION_LIST_FAILURE })
    }
}

// watcher saga methods 
function* watchGetAIDataForSalesRep(): Generator {
    yield takeLatest(GET_AI_RECOMMENDATION_SALES_REP_CLASSIFICATION, getAIDataForSalesRep)
}
function* watchGetSalesRepClassificationListData(): Generator {
    yield takeLatest(GET_SALES_REP_CLASSIFICATION_LIST, getSalesRepClassificationListData)
}

//Root saga 
export default function* salesRepClassificationsaga(): Generator {
    yield all([
        fork(watchGetAIDataForSalesRep),
        fork(watchGetSalesRepClassificationListData)
    ])
}